import { useState } from 'react';
import { t } from 'ttag';

import CheckIcon from '@svg/check.svg';
import BonubackIcon from '@svg/bonusback.svg';
import MessageInfoIcon from '@svg/message-info.svg';
import { Button } from '@ui/Button';
import { Skeleton } from '@ui/Skeleton';
import { ProductSizeSelect, ProductSizeSelectSkeleton, Size } from '@components/ProductSizeSelect';
import { BonusbackInfoModal, ModalData as BonusbackModalData } from '@components/BonusbackInfoModal';

import s from './ProductDetailsCreateOrderButtons.sss';

interface BonusbackInfo {
  amountText: string,
  popUp: BonusbackModalData[]
}

interface Props {
  sizes: Size[],
  selectedSizeIds: number[],
  isInStickyBar?: boolean,
  isInBasket: boolean,
  isCanSwap?: boolean,
  isLoading: boolean,
  bonusbackInfo?: BonusbackInfo | null,
  onSwap: () => void,
  onBuyNow: () => void,
  onAddToCart: () => void,
  onSelectSize: (sizeId: number) => void,
}

export const ProductDetailsCreateOrderButtons: React.FC<Props> = ({
  sizes,
  selectedSizeIds,
  isInStickyBar,
  isInBasket,
  isCanSwap,
  isLoading,
  bonusbackInfo,
  onSwap,
  onBuyNow,
  onAddToCart,
  onSelectSize,
}) => {
  const [isBonusbackInfoModalOpen, setIsBonusbackInfoModalOpen] = useState(false);
  if (isLoading) {
    if (isInStickyBar) {
      return (
        <Skeleton
          width="80px"
          height="40px"
        />
      );
    }

    return (
      <div className={s.root}>
        <ProductSizeSelectSkeleton />

        <div className={s.buttons}>
          <Skeleton
            width="100%"
            height="48px"
          />
        </div>
      </div>
    );
  }


  if (isInStickyBar) {
    if (isCanSwap) {
      return (
        <Button
          className={s.stickyBarButton}
          theme="swap"
          disabled={isLoading}
          onClick={onSwap}
        >
          {t`Отримати`}
        </Button>
      );
    }

    return (
      <Button
        className={s.stickyBarButton}
        disabled={isLoading}
        onClick={onBuyNow}
      >
        {t`Купити`}
      </Button>
    );
  }

  return (
    <>
      <div className={s.root}>
        {!!sizes.length && (
          <>
            <p className={s.title}>
              {t`Розміри:`}
            </p>

            <ProductSizeSelect
              sizes={sizes}
              selectedSizesIds={selectedSizeIds}
              onSelectSize={onSelectSize}
            />
          </>
        )}

        {!!bonusbackInfo && (
          <Button
            className={s.bonusbackButton}
            theme="text"
            onClick={() => setIsBonusbackInfoModalOpen(true)}
          >
            <BonubackIcon
              className={s.bonusbackIcon}
              width='24'
              height='24'
            />

            <span className={s.bonusbackInfo}>
              {bonusbackInfo.amountText}

              <MessageInfoIcon
                className={s.infoIcon}
                width='16'
                height='16'
              />
            </span>
          </Button>
        )}

        <div className={s.buttons}>
          {isCanSwap ? (
            <Button
              theme="swap"
              disabled={isLoading}
              onClick={onSwap}
            >
              {t`Отримати товар`}
            </Button>
          ) : (
            <>
              <Button
                className={s.buyNow}
                onClick={onBuyNow}
                disabled={isLoading}
              >
                {t`Купити`}
              </Button>
              <Button
                className={s.addToBasketButton}
                theme="secondary"
                onClick={onAddToCart}
                disabled={isLoading}
              >
                {isInBasket ? (
                  <>
                    <CheckIcon className={s.check} />
                    &nbsp;
                    {t`Товар в кошику`}
                  </>
                ) : t`Додати до кошика`}
              </Button>
            </>
          )}
        </div>
      </div>

      {!!bonusbackInfo?.popUp?.length && (
        <BonusbackInfoModal
          isOpen={isBonusbackInfoModalOpen}
          data={bonusbackInfo.popUp}
          onClose={() => setIsBonusbackInfoModalOpen(false)}
        />
      )}
    </>
  );
};
